import { useState } from "react";
import { FalloutPlayer, GameData, FalloutCharacter, FalloutEquippedWeapon, OpenFireRequest, FalloutCharacterStatus } from "../Data/Response";
import EnemyTargetView, { Target } from "./EnemyTargetView";
import SelectTargetView from "./SelectTargetsView";
import SupportingFireView from "./SupportingFireView";

type OpenFireSequenceArgs = {
    player: FalloutPlayer;
    game: GameData;
    actor: FalloutCharacter;
    equippedItem: FalloutEquippedWeapon;
    startOpenFire: (args: OpenFireRequest) => Promise<void>;
}

enum Phase {
    SelectTarget,
    AddSupport,
    Summary
}

const OpenFireSequenceView: React.FC<OpenFireSequenceArgs> = (args) => {
    const [targets, setTargets] = useState<Target[]>([]);
    const [support, setSupport] = useState<FalloutCharacter[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [enabledTraitIds, setEnabledTraits] = useState<string[]>([]);
    const [phase, setPhase] = useState(Phase.SelectTarget);
    // const [state, setState] = useState<OpenFireState>("Select Target");
    // const [targettingComplete, setTargettingComplete] = useState(false);

    const isArea = args.equippedItem.traits.map(t => t.id).includes("area");
    console.log(targets);
    /**
     * Need to build out Area
     * 
     * will change the logic on when the supporting fire screen shows
     * will require a list of all characters, not just enemeies.
     * will require a button to move to next screen.
     */
    if (phase === Phase.Summary) {
        return <div>
            <h1>Open Fire!!</h1>
            <p>{args.actor.name} is Opening Fire!</p>
            <p>Targeting: {targets.map(t => t.playerCharacter.name).join(', ')}</p>
            {support && <p>With support from: {support.map(pc => pc.name).join(', ')}</p>}

            <p>{args.equippedItem.name}</p>
            Critical Effects:
            <ul>{args.equippedItem.criticalEffects.map(t => {
                return <li>{t.fullName}</li>
            })}</ul>
            Traits:
            <ul>{args.equippedItem.traits.map(t => {
                return <li>{t.fullName}</li>
            })}</ul>
            <p>Send to server here?</p>
            <p>Maybe weapon traits?</p>
            <button
                onClick={async e => {
                    setIsLoading(true);
                    try {
                        await args.startOpenFire({
                            GameId: args.game.id,
                            ActingUserId: args.player.userId,
                            ActingCharacterId: args.actor.id,
                            WeaponId: args.equippedItem.id,
                            Targets: targets.map(t => {
                                return {
                                    CharacterId: t.playerCharacter.id,
                                    DistanceInInches: t.distance,
                                    IsWideOpen: t.isWideOpen
                                }
                            }),
                            SupportingFireCharacterIds: (support ?? []).map(pc => pc.id),
                            EnabledTraitIds: enabledTraitIds,
                        });
                        setIsLoading(false);
                    } catch (e) {
                        console.log("ERROR");
                        console.log(e);
                    }
                }}
                disabled={isLoading}
            >FIRE!!</button>
        </div>
    }


    if (phase === Phase.AddSupport) {
        return <div>
            <h1>Open Fire!!</h1>
            <p>{args.actor.name} is Opening Fire!</p>
            <p>Targeting: {targets.map(t => t.playerCharacter.name).join(', ')}</p>
            <SupportingFireView player={args.player} actor={args.actor} setSupport={s => {
                setSupport(s);
                setPhase(Phase.Summary)
            }} />
        </div>
    }

    if (isArea) {
        const enemyTargets = args.game.falloutPlayers
            .flatMap(p => p.crew?.characters ?? [])
            .filter(c => c.state.status === "active" && c.id !== args.actor.id)
        return <div>
            <h2>Open Fire</h2>
            <p>{args.actor.name}'s weapon has the area trait. Please select a number of characters to target.</p>
            <ul>
                {enemyTargets.map(c => {
                    return <EnemyTargetView
                        playerCharacter={c}
                        setTarget={function (newTarget?: Target): void {
                            setTargets(prev => {
                                if (newTarget === null) {
                                    return prev.filter(t => t.playerCharacter.id !== c.id);
                                }
                                if (prev.map(t => t.playerCharacter.id).includes(newTarget.playerCharacter.id)) {
                                    return prev;
                                }
                                return [...prev, newTarget];
                            })
                        }}
                        isAreaAttack={true}
                    />
                })}
            </ul>
            <button
                disabled={targets.length < 1}
                onClick={e => {
                    setPhase(Phase.Summary);
                }}
            >Continue</button>
        </div>
    } else {
        const target = (targets.length > 0) ? targets[0] : null;

        return <StandardOpenFireTargetSelectView
            target={target}
            actor={args.actor}
            enabledTraitIds={enabledTraitIds}
            setEnabledTraitIds={setEnabledTraits}
            equippedItem={args.equippedItem}
            game={args.game}
            player={args.player}
            setTarget={t => {
                setTargets([t]);
                setPhase(Phase.AddSupport);
            }}
        />
    }
}

interface StandardOpenFireTargetSelectArgs {
    target?: Target;
    actor: FalloutCharacter;
    enabledTraitIds: string[];
    setEnabledTraitIds: React.Dispatch<React.SetStateAction<string[]>>;
    equippedItem: FalloutEquippedWeapon;
    player: FalloutPlayer;
    game: GameData;
    setTarget: (target: Target) => void;
}

const StandardOpenFireTargetSelectView: React.FC<StandardOpenFireTargetSelectArgs> = args => {

    if (args.target === null) {
        return <div>
            <h1>Open Fire!!</h1>
            <p>{args.actor.name} is Opening Fire!</p>
            <p>
                Aim: <input
                    type="checkbox"
                    checked={args.enabledTraitIds.includes('aim')}
                    onChange={e => {
                        args.setEnabledTraitIds(e.target.checked ? ['aim'] : []);
                    }}
                    disabled={args.equippedItem.traits.find(t => t.id === 'aim') === undefined}
                />
            </p>
            <SelectTargetView
                enemyTargets={args.game.falloutPlayers.filter(p => p.userId !== args.player.userId).flatMap(p => p.crew?.characters ?? [])}
                setTarget={args.setTarget}
            />
        </div>
    }

}

export default OpenFireSequenceView;